import { forwardRef } from 'react';
import {
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  MenuItem,
  MenuItemProps,
} from '@mui/material';

import { Icon, IconOption } from '@components/base';

export type MenuListButtonProps = MenuItemProps & {
  leftIcon?: IconOption;
  rightIcon?: IconOption;
};

export const MenuListButton = forwardRef<HTMLLIElement, MenuListButtonProps>(
  ({ children, leftIcon, rightIcon, ...rest }, ref) => (
    <MenuItem ref={ref} {...rest}>
      {leftIcon && (
        <ListItemIcon>
          <Icon name={leftIcon} />
        </ListItemIcon>
      )}

      {typeof children === 'string' ? <ListItemText>{children}</ListItemText> : children}

      {rightIcon && (
        <ListItemSecondaryAction>
          <Icon name={rightIcon} />
        </ListItemSecondaryAction>
      )}
    </MenuItem>
  )
);

MenuListButton.displayName = 'MenuListButton';
